import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ConfigurationSection, SpaceBetweenRow } from "@features/settings/pages/StyleComponents";
import { BodyLarge, BodyRegular } from "../../atoms/fonts/Body";
import Colours from "../../atoms/Colours";
import { Switch } from "../../atoms/Switch";
import { updateCompanySetting } from '@features/settings/services/CompanyService';
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser, selectIsInTeams, updateCurrentUser } from '@shared/store/auth.duck';
import { failureNotification } from '@shared/store/notification.duck';
import { SimpleSpinner } from "../../atoms/SimpleSpinner";
import { useTranslation } from "react-i18next";
import { isPremiumTierUser } from '@shared/utils/AccessControl';
import { Column } from "../../atoms/StructuralLayout";

const FIELD = 'LOCKERS'

export function LockersSetting() {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const isInTeams = useSelector(selectIsInTeams);
  const lockersEnabled = user?.companyEntity?.lockersEnabled;
  const {t} = useTranslation();

  const isTierRestricted = !isPremiumTierUser(user);

  const onChange = async (value: boolean) => {
    try {
      setIsLoading(true);
      await updateCompanySetting(FIELD, value);
      dispatch(updateCurrentUser(true));
    } catch (e: any) {
      dispatch(failureNotification('Failed to update setting, please wait a minute.'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ConfigurationSection className={'domainBasedSignup__section'}>
      <SpaceBetweenRow>
        <Column>
          <BodyLarge colour={Colours.blue}>{t('settings.lockers.title')}</BodyLarge>
          {isTierRestricted && (
            isInTeams
              ? <BodyRegular style={{marginTop: 4, color: Colours.darkGrey}}>
                  {t('settings.lockers.not-enabled')}{' '}
                  <a href="mailto:support@team-today.com">support@team-today.com</a>
                </BodyRegular>
              : <BodyRegular style={{marginTop: 4, color: Colours.darkGrey}}>
                  {t('settings.lockers.upsell')}{' '}
                  <Link to="/manage/payments">{t('settings.lockers.upsell-link')}</Link>
                </BodyRegular>
          )}
        </Column>
        {isLoading ? <SimpleSpinner size={32} /> : <Switch value={!!lockersEnabled} label=""
                                                           disabled={isLoading || isTierRestricted}
                                                           onChange={onChange}/>}
      </SpaceBetweenRow>
      <BodyRegular>{t('settings.lockers.subtitle')}</BodyRegular>
    </ConfigurationSection>
  )
}
